import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoWdl = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 120",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#009abf}.cls-3{fill:#0a99be}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "Artboard 1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M90.2 90.9c0-7.4.9-12.8.9-19.6 0-4-1.9-7.9-8.8-8V58c6.9-.1 8.8-4 8.8-7.9 0-7-.9-12.4-.9-19.8 0-10.6 3.8-13.6 11.9-13.6h4.6v4.8H104c-5.5 0-7 2.7-7 9.3 0 6.2.5 11.5.5 18.5 0 6.6-1.7 9.9-6.1 11.1v.4c4.4 1.2 6.1 4.6 6.1 11.1 0 7-.5 12.3-.5 18.5 0 6.6 1.4 9.3 7 9.3h2.7v4.8h-4.6c-7.9 0-11.9-3.1-11.9-13.6ZM262.4 99.7h2.7c5.5 0 7-2.7 7-9.3 0-6.2-.5-11.5-.5-18.5 0-6.5 1.7-9.9 6.1-11.1v-.4c-4.4-1.2-6.1-4.5-6.1-11.1 0-6.9.5-12.3.5-18.5 0-6.6-1.4-9.3-7-9.3h-2.7v-4.8h4.6c8.1 0 11.9 3 11.9 13.6 0 7.4-.9 12.8-.9 19.8 0 3.9 1.9 7.8 8.8 7.9v5.3c-6.9.1-8.8 4-8.8 8 0 6.8.9 12.2.9 19.6 0 10.6-3.8 13.6-11.9 13.6h-4.6Z"
		}),
		/* @__PURE__ */ _jsx("text", {
			transform: "translate(108.16 87.26)",
			style: {
				isolation: "isolate",
				fontSize: 88,
				fill: "#333",
				fontFamily: "Courier"
			},
			children: "wdl"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-3",
			d: "m26.2 69.65-12.9 7.5v15l12.9 7.5 13-7.5v-15l-13-7.5zM55 44.94l-12.99 7.5v15l7.19 4.15-7.19 4.15v6.64L55 74.94l12.99-7.5v-15L55 44.94zM52.19 43.65 39.2 36.21v-8.36l-13-7.5-12.9 7.5v15l12.9 7.5 13-7.5L46.39 47l5.8-3.35z"
		})
	]
});
export default SvgLogoWdl;
